import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import { Button } from '@famly/mf_input_button';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { statFormContext } from '@famly/stat_forms_form-context';
import { StatFormSubmitAndDeleteButtons } from './stat-form-submit-and-delete-buttons';
import { StatFormInternal } from './stat-form-internal';
const StyledForm = styled.form `
    padding: ${props => { var _a; return props.theme.mf.spacing((_a = props.$padding) !== null && _a !== void 0 ? _a : 6); }};
    height: ${props => (props.$isBase ? '100%' : '')};

    & input {
        &[type='text'],
        &[type='password'],
        &[type='date'],
        &[type='datetime'],
        &[type='datetime-local'],
        &[type='month'],
        &[type='week'],
        &[type='email'],
        &[type='number'],
        &[type='search'],
        &[type='tel'],
        &[type='time'],
        &[type='url'],
        &[type='color'],
        textarea {
            margin-bottom: 0;
        }
    }
`;
export const StatForm = (props) => {
    const { secondary, children, id, type = 'submit', cancelText, submitText, lockedText, dataE2eLockedButtonId, dataE2eSubmitButtonId, dataE2eCancelButtonId, dataE2eDeleteButtonId, onCancel, onSubmit, isDisabled, isLocked, onDelete, isLoading, isDeleteDisabled = isDisabled, padding, } = props;
    const { isBase } = useBreakpoints();
    const onSubmitHandler = React.useCallback((e) => {
        e.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }, [onSubmit]);
    return (_jsx(statFormContext.Provider, { value: { secondary }, children: _jsxs(StyledForm, { "$isBase": isBase, "$padding": padding, method: "post", onSubmit: onSubmitHandler, id: id, "data-e2e-id": props['data-e2e-id'], children: [children, type !== 'custom' ? (_jsxs(StatFormInternal, { type: type, children: [type !== 'submitAndDelete' && onCancel ? (_jsx(Button, { onClick: onCancel, variant: "tertiary", "data-e2e-id": dataE2eCancelButtonId, text: cancelText !== null && cancelText !== void 0 ? cancelText : i18next.t($ => $.cancel) })) : null, type !== 'naked' ? (_jsxs(_Fragment, { children: [type === 'submitAndDelete' && onSubmit && onDelete ? (_jsx(StatFormSubmitAndDeleteButtons, { submitText: submitText, lockedText: lockedText, isDisabled: isDisabled, isLocked: isLocked, isDeleteDisabled: isDeleteDisabled, isLoading: isLoading, onDelete: onDelete, onCancel: onCancel, dataE2eLockedButtonId: dataE2eLockedButtonId, dataE2eCancelButtonId: dataE2eCancelButtonId, dataE2eDeleteButtonId: dataE2eDeleteButtonId, dataE2eSubmitButtonId: dataE2eSubmitButtonId })) : null, type === 'submit' && onSubmit ? (_jsx(Button, { type: "submit", icon: isLocked ? 'lock' : undefined, variant: isLocked ? 'critical' : 'primary', isLoading: isLoading, isDisabled: isDisabled, "data-e2e-id": isLocked ? dataE2eLockedButtonId : dataE2eSubmitButtonId, text: isLocked
                                        ? (lockedText !== null && lockedText !== void 0 ? lockedText : i18next.t($ => $.react.staffingAttendance.form.components.translations.json
                                            .unlockToEdit))
                                        : (submitText !== null && submitText !== void 0 ? submitText : i18next.t($ => $.confirm)) })) : null, type === 'delete' && onSubmit ? (_jsx(Button, { "data-e2e-id": dataE2eDeleteButtonId, type: "button", isLoading: isLoading, variant: "critical", onClick: onSubmit, isDisabled: isDisabled, text: submitText || i18next.t($ => $.delete) })) : null] })) : null] })) : null] }) }));
};
